var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"index-mappings-tab-content\" ng-show=\"iMTContentCtrl._toRender\">\n<div hljs hljs-source=\"iMTContentCtrl._toRender\"></div>\n</div>";
var id1="components/index-mappings-tab-content/index-mappings-tab-content.template.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;


//////////////////
// WEBPACK FOOTER
// ./ui/src/components/index-mappings-tab-content/index-mappings-tab-content.template.html
// module id = 912
// module chunks = 0